import { Controller } from "@hotwired/stimulus"
import { evaluateConfig } from "../modules/silent_config"

// Silent-config playground for "One wrong word, up to 90 seconds of silence".
// Reads the typed config key, asks the pure module whether the downstream gem
// would ever read it, and renders the store status plus the effective Chrome
// command line. The right key lands the flags; anything else is stored, never
// used, and Chrome launches bare.
export default class extends Controller {
  static targets = ["input", "status", "command", "received"]

  connect() {
    this.update()
  }

  // Click handler for the key chips. Reads the chip's key from the Stimulus
  // action param, drops it into the input, and re-renders through update().
  select(event) {
    const key = event.params.key ?? ""
    this.inputTarget.value = key
    this.update()
  }

  update() {
    const result = evaluateConfig(this.inputTarget.value)
    this._renderStatus(result)
    this._renderReceived(result)
    // textContent only — the key is user-controlled, so never innerHTML it.
    this.commandTarget.textContent = result.commandLine
    this.commandTarget.classList.toggle("scp-command--success", result.applied)
  }

  _renderStatus(result) {
    this.statusTarget.textContent = result.status
    this.statusTarget.style.cssText =
      "display:inline-block;padding:2px 8px;border-radius:4px;font-size:12px;" +
      (result.applied ? "background:#dcfce7;color:#166534;" : "background:#fef2f2;color:#991b1b;")
  }

  _renderReceived(result) {
    if (!this.hasReceivedTarget) return
    this.receivedTarget.textContent = result.applied
      ? `{ ${result.ferrumReceived.map(f => `"${f.replace(/^--/, "")}"=>nil`).join(", ")} }`
      : "{}  (default — your flags are gone)"
  }
}
